<template>
  <div class="index" id="anchor">
    <Seacher></Seacher>
    <div class="tranbox">
      <div class="tranboxtit">Transactions</div>
      <div class="indexbox">
        <div class="iboxleft">
          <div class="iboxtit">Txn Count</div>
          <div class="iboxcon">{{ Number(totalTxCount).toLocaleString() }}</div>
          <div class="iboxbottom">
            <div class="ibttol">
              +{{ Number(yesterdayTxCount).toLocaleString() }}
            </div>
            <div class="ibttor">Last 24h</div>
          </div>
        </div>
      </div>
      <div class="indexbox">
        <div class="iboxleft">
          <div class="iboxtit">Trading Volume</div>
          <div class="iboxcon">{{ totalTradingValume }} TTOS</div>
          <div class="iboxbottom">
            <div class="ibttol">
              {{ yesterdayTradingValume }} TTOS
            </div>
            <div class="ibttor">Last 24h</div>
          </div>
        </div>
      </div>
      <div class="trancharts">
        <div class="charts_tit">
          <div class="charts_l">Daily Txn Distribution</div>
          <!-- <div class="charts_btn">
            <span> More</span> <img src="../../assets/m/home/more.png" />
          </div> -->
        </div>
        <div class="charts" v-if="chartdata.length <= 0">
          <img
            style="width: 300px; height: 200px"
            src="@/assets/pc/BkHash/zanwushuju.png"
          />
        </div>
        <div class="charts">
          <div id="charts" ref="chart" style="height: 210px"></div>
          <div class="chartsul">
            <div
              class="chartli"
              v-for="(item, index) in chartdata.slice(0, 7)"
              :key="index"
            >
              <div class="chartlil">
                <span class="markers"></span><span>{{ item.name }}</span>
              </div>
              <div class="chartlir">
                <span>
                  {{
                    new Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                      maximumFractionDigits: 10,
                    }).format(item.value)
                  }}
                </span>
                <span v-if="item.sums !== 'NaN'">({{ item.sums }}%)</span>
                <span v-else>(0%)</span>
              </div>
            </div>
            <!-- <div class="chartli">
              <div class="chartlil"><span class="markers"></span><span>USDT Token</span></div>
              <div class="chartlir">
                <span>1,854,499 calls </span><span>(97.32%)</span>
              </div>
            </div>
            <div class="chartli">
              <div class="chartlil"><span class="markers"></span><span>USDT Token</span></div>
              <div class="chartlir">
                <span>1,854,499 calls </span><span>(97.32%)</span>
              </div>
            </div>
            <div class="chartli">
              <div class="chartlil"><span class="markers"></span><span>USDT Token</span></div>
              <div class="chartlir">
                <span>1,854,499 calls </span><span>(97.32%)</span>
              </div>
            </div> -->
          </div>
        </div>
        <!-- <div class="charts">
          <div
            id="charts"
            ref="chart"
            style="width: 613px; height: 356px"
          ></div>
        </div> -->
      </div>
    </div>
    <!-- translist start -->
    <div class="translist">
      <div class="Block_Top notranslate">
        <span class="notranslate"
          >Transactions<b class="notranslate"
            >({{ Number(total).toLocaleString() }})</b
          ></span
        >
      </div>
      <div class="resume-list">
        <div class="pool_main">
          <div class="tags">
            <div class="indexList">
              <div class="Block_list">
                <ul class="block_list_Top">
                  <li>Txn Hash</li>
                  <li>Block</li>
                  <li class="xila">Type</li>
                  <li>Age</li>
                  <li>From</li>
                  <li>To</li>
                  <li>Amount</li>
                </ul>
              </div>
              <div class="Block_List_center notranslate">
                <ul>
                  <li v-for="(transfer, index) in list" :key="index">
                    <p @click="goDetail('hash', transfer)">
                      {{ transfer.txHash }}
                    </p>
                    <p @click="goDetail('height', transfer.height)">
                      {{ transfer.height }}
                    </p>
                    <p>{{ transfer.type }}</p>
                    <p>{{ transfer.tradeTime }}</p>
                    <p
                      v-if="
                        transfer.type == 'Unstake' ||
                        transfer.fromAddress == 'Unpledge'
                      "
                    >
                      Unstake
                    </p>
                    <p v-if="transfer.type == 'Bonus'" style="color: #898b8d">
                      Bonus
                    </p>
                    <p
                      v-if="
                        (transfer.type == 'Transfer' ||
                          transfer.type == 'Delegate' ||
                          transfer.type == 'Withdraw' ||
                          transfer.type == 'Signature Rewards' ||
                          transfer.type == 'Stake' ||
                          transfer.type1 == 8 ||
                          transfer.type1 == 7 ||
                          transfer.type1 == -1) &&
                        transfer.fromAddress !== 'Unpledge'
                      "
                      @click="goDetail('transfer', transfer.fromAddress1)"
                    >
                      {{ transfer.fromAddress }}
                    </p>
                    <!-- <p>Bonus</p> -->

                    <p
                      v-if="
                        transfer.type == 'Transfer' ||
                        transfer.type == 'Delegate' ||
                        transfer.type == 'Withdraw' ||
                        transfer.type == 'Unstake' ||
                        transfer.type == 'Bonus' ||
                        transfer.type1 == 8 ||
                        transfer.type1 == 7
                      "
                    >
                      <span
                        v-if="transfer.toAddress1 !== ''"
                        @click="goDetail('transfer', transfer.toAddress1)"
                        >{{
                          transfer.toAddress[0] == "Pledge"
                            ? "Stake"
                            : transfer.toAddress
                        }}
                      </span>
                      <span style="color: #898b8d; display: block" v-else
                        >...</span
                      >
                    </p>
                    <p v-if="transfer.type1 == -1" style="color: #898b8d">
                      ...
                    </p>
                    <!-- <p
                      v-else
                      style="color: #898b8d"
                    >
                     ...
                    </p> -->
                    <p
                      v-if="transfer.type == 'Signature Rewards'"
                      style="color: #898b8d"
                    >
                      Signature Rewards
                    </p>
                    <p v-if="transfer.type == 'Stake'" style="color: #898b8d">
                      Stake
                    </p>
                    <!-- 代币 -->
                    <!-- <p
                      v-if="
                        transfer.standard == 'ERC-20' && transfer.type1 == 7
                      "
                    >
                      {{ transfer.tokenAmount }}
                      <img
                        :src="transfer.logo"
                        style="
                          width: 24px;
                          height: 24px;
                          margin-top: 10px;
                          border-radius: 50%;
                        "
                      />{{ transfer.symbol }}
                    </p> -->

                    <!-- 合约执行 -->
                    <p
                      v-if="
                        transfer.standard == 'ERC-721' && transfer.type1 == 7
                      "
                      style="color: #898b8d !important"
                    >
                      <img
                        :src="transfer.logo"
                        style="
                          width: 24px;
                          height: 24px;
                          border-radius: 4px;
                          margin-top: 10px;
                          margin-right: 4px;
                        "
                      /><span>{{ transfer.contractName }}</span>
                    </p>
                    <p
                      v-if="
                        transfer.standard == 'ERC-20' && transfer.type1 == 7
                      "
                      style="color: #fff"
                      @click="cHash1(index)"
                    >
                      <span v-if="transfer.tokenAmount !== 'NaN'">{{
                      transfer.tokenAmount
                      }}</span>
                      <img
                        :src="transfer.logo"
                        style="
                          width: 24px;
                          height: 24px;
                          border-radius: 50%;
                          margin-top: 10px;
                        "
                      />
                      <span v-if="transfer.symbol.length > 12"
                        >{{ transfer.symbol.slice(0, 8) }}...</span
                      >
                      <span v-else>{{ transfer.symbol }}</span>
                      <!-- <span style="width: 60px;overflow:hidden;text-align: left;
white-space: nowrap;
text-overflow: ellipsis;
-o-text-overflow:ellipsis;">{{ transfer.symbol }}</span> -->
                    </p>
                    <p
                      v-if="
                        transfer.standard == 'ERC-20' && transfer.type1 == 8
                      "
                      style="color: #fff"
                      @click="cHash1(index)"
                    >
                      <span v-if="transfer.tokenAmount > 999">
                        {{ transfer.tokenAmount }}</span
                      >
                      <span v-else>{{ transfer.tokenAmount }}</span>

                      <img
                        :src="transfer.logo"
                        style="
                          width: 24px;
                          height: 24px;
                          border-radius: 50%;
                          margin-top: 10px;

                          margin-right: 6px;
                        "
                      />{{ transfer.symbol }}
                    </p>
                    <!-- 合约执行 -->
                    <p
                      v-if="
                        transfer.standard == 'ERC-721' &&
                        transfer.type1 == 8 &&
                        transfer.tokenAmount !== ''
                      "
                      style="color: #fff; cursor: pointer"
                      @click="cHash(index)"
                    >
                      <img
                        :src="transfer.logo"
                        style="
                          height: 24px;
                          margin-top: 10px;
                          margin-right: 6px;
                          border-radius: 4px;
                        "
                      />{{ transfer.contractName }}

                      {{ transfer.tokenAmount.split(",")[0] }}
                      <!-- {{ Number(transfer.tokenAmount.split(",")[0]).toLocaleString() }} -->
                    </p>
                    <!-- 不被识别的合约类型 -->
                    <p
                      v-if="
                        transfer.standard == 'ERC-721' &&
                        transfer.type1 == 8 &&
                        transfer.functions == 'Contract Execute'
                      "
                    >
                      <!-- <img
                            v-if="item.tokenAmount ==''"
                              :src="item.logo"
                              style="width: 34px; height: 34px; border-radius: 50%"
                            /> -->

                      <img
                        v-if="transfer.nftImageList == ''"
                        :src="imgurl"
                        style="
                          width: 24px;
                          margin-top: 10px;
                          margin-right: 6px;
                          height: 24px;
                          border-radius: 50%;
                        "
                      />
                      <img
                        v-if="transfer.nftImageList !== ''"
                        :src="transfer.logo"
                        style="
                          /* width: 24px; */
                          margin-top: 10px;
                          margin-right: 6px;
                          height: 24px;
                          border-radius: 50%;
                        "
                      />

                      <span style="margin-top: 4px">{{
                        transfer.contractName
                      }}</span>
                    </p>
                    <!-- 不被识别的合约类型 -->
                    <!-- 类型为8和ERC-721 functions setBaseTokenURI functions balanceOf -->
                    <p
                      v-if="
                        transfer.standard == 'ERC-721' &&
                        transfer.type1 == 8 &&
                        (transfer.functions == 'setBaseTokenURI' ||
                          transfer.functions == 'balanceOf')
                      "
                    >
                      <!-- <img
                            v-if="item.tokenAmount ==''"
                              :src="item.logo"
                              style="width: 34px; height: 34px; border-radius: 50%"
                            /> -->

                      <img
                        v-if="transfer.logo !== ''"
                        :src="transfer.logo"
                        style="
                          /* width: 24px; */
                          margin-top: 10px;
                          margin-right: 6px;
                          height: 24px;
                          border-radius: 4px;
                        "
                      />

                      <span style="margin-top: 4px">{{
                        transfer.contractName
                      }}</span>
                    </p>
                    <!-- <p
                      v-if="
                        transfer.standard == 'ERC-721' &&
                        transfer.type1 == 8 &&
                        transfer.tokenAmount == ''
                      "
                      style="color: #8d8d8d"
                    >
                      <img
                        :src="transfer.logo"
                        style="
                          width: 24px;
                          height: 24px;
                          margin-top: 10px;
                          margin-right: 6px;
                          border-radius: 4px;
                        "
                      />{{ transfer.contractName }}
                      {{ transfer.tokenAmount.split(",")[0] }}
                    </p> -->
                    <p
                      v-if="
                        (transfer.type1 !== 8 || transfer.type1 !== 7) &&
                        transfer.standard == ''
                      "
                    >
                      <!-- {{ transfer.amount }} -->
                      <!-- {{ Number(transfer.amount).toLocaleString() }} -->
                      {{
                        new Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                          maximumFractionDigits: 10,
                        }).format(transfer.amount)
                      }}
                      TTOS
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="block">
          <el-pagination
            background
            small
            :current-page.sync="pageNum"
            :page-size="20"
            :pager-count="5"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- translist end -->
  </div>
</template>

<script>
const echarts = require("echarts");

import Seacher from "@/components/m/Seacher.vue";
import { TradeList, GetTxList } from "../../assets/server/api.js";
import {
  formatSeconds,
  listType,
  getSubStr,
  timestampConvertTime,
  countDecimalPlaces,
  formattedNumber
} from "../../utils/utils.js";
export default {
  components: {
    Seacher,
  },
  data() {
    return {
      pageSize: 1,
      total: null,
      pageNum: 1,
      pagerCount: 0,
      transferList: [],
      //交易列表开始
      yesterdayTradingValume: "",
      totalTxCount: "",
      totalTradingValume: "",
      yesterdayTxCount: "",
      todayCallContractCount: 0, // 合约调用次数
      todayClaimingBonusCount: 0, //图表 申领奖励次数
      todayInvestAndDisInvestCount: 0, //图表  投资和解投资次数
      todayStakeAndUnstakeCount: 0, //图表  质押和解质押次数
      todayTransferCount: 0, //图表  转账次数
      txCount: "",
      pastdays: "",
      list: [],
      chartdata: [],
      imgurl: require("@/assets/pc/Index/indexlogo.png"),
      imgurl1: require("@/assets/pc/Index/nft.png"),
      //交易列表结束
    };
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  created() {
    this.pageNum = 1;
  },
  mounted() {
    this.getTradeList();
  },
  destroyed() {},
  methods: {
    check_is_img(url) {
      return (
        url.match(/\.(jpeg|jpg|gif|png|GIF|PNG|JPG|JPEG|SVG|svg)$/) != null
      );
    },
    cHash(Index) {
      // console.log(Index);
      let params = {
        contractAddress: this.list[Index].contractAddress,
        tokenId: this.list[Index].tokenAmount,
      };
      //  console.log(params);
      this.$router.push({ path: "/m/NFTslistdetail", query: params });
    },
    cHash1(Index) {
      let params = {
        contractAddress: this.list[Index].contractAddress,
      };
      this.$router.push({ path: "/m/Overaddress", query: params });
    },
    initCharts() {
      this.lineChart = echarts.init(this.$refs.chart);

      let option = {
        tooltip: {
          confine: true,
          appendToBody: true,

          // position: ['30%', '10%'],
          // trigger: "item",
          backgroundColor: "rgba(36,41,49,0.9)", //设置背景图片 rgba格式
          color: "rgba(255, 255, 255, 0.5)",
          // marginright:5,
          // position: [20, 0],

          // borderWidth: "1", //边框宽度设置1
          // borderColor: "gray", //设置边框颜色
          formatter: function (params) {
            // console.log(params);
            //  console.log(params.data.name);
            // console.log(params[0].value);
            // console.log(this.pastdays);
            let str =
              '<p style="text-align:left;z-index:9999">' +
              '<span style="color:#fff;font-size:12px;">' +
              params.data.time +
              "(UTC)" +
              "</span>" +
              "</br>" +
              "<span style='color:#fff;font-size:12px;'>" +
              params.marker +
              params.data.name +
              "</span>" +
              "<br/>" +
              '<span style="color:#fff;font-size:12px;margin-left:16px;">' +
              "Percentage :" +
              params.percent +
              "%" +
              "</span>" +
              "<br/>" +
              '<span style="color:#fff;font-size:12px;margin-left:16px;">' +
              "Txn Counts :" +
              new Intl.NumberFormat("en-US", {
                minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                maximumFractionDigits: 10,
              }).format(params.data.value) +
              "</span>" +
              "</p>";
            return str;
          },
        },

        // legend: {
        //   selectedMode: false,
        //   show: true,
        //   orient: "vertical",
        //   x: "2%", //可设定图例在左、右、居中
        //   y: "50%",
        //   icon: "circle",
        //   padding: [0, 50, 0, 0],
        //   itemHeight: 9, // 图例icon高度
        //   itemWidth: 9, // 图例icon宽度
        //   align: "left", // 图例icon在左侧
        //   itemGap: 20, // 图例每项之间的间隔。
        //   itemHeight: 14, //  图例标记的图形高度。
        //   formatter: function (name) {
        //     // 添加
        //     let total = 0;
        //     let target;
        //     for (let i = 0; i < data.length; i++) {
        //       total += data[i].value;
        //       if (data[i].name === name) {
        //         target = data[i].value;
        //       }
        //     }
        //     if (total == 0) {
        //       var arr = ["{a|" + name + "}", "{b|" + 0 + "%}"];
        //       //  console.log(arr);
        //       return arr.join("  ");
        //     } else {
        //       var arr = [
        //         "{a|" + name + "}",

        //         "{c|" + target + "}",
        //         "{b|" + " (" + ((target / total) * 100).toFixed(2) + ")" + "%}",
        //       ];
        //       // console.log(arr);
        //       return arr.join("  ");
        //     }

        //   },
        //   textStyle: {
        //     // 添加
        //     padding: [0, 0, 0, 0],
        //     rich: {
        //       a: {
        //         fontSize: 14,
        //         width: 152,
        //         color: "rgba(255,255,255,0.5)",
        //       },
        //       b: {
        //         fontSize: 14,
        //         width: 10,
        //         color: "rgba(255,255,255,0.5)",
        //         align: "left",
        //       },
        //       c: {
        //         fontSize: 14,
        //         color: "#fff",
        //         width: 70,
        //         align: "right",
        //       },
        //     },
        //   },
        // },

        color: ["#00C785", "#14C9C9", "#F7BA1E", "#722ED1", "#3491FA"],
        series: [
          {
            // name: "Access From",
            type: "pie",

            radius: ["25%", "65%"],
            center: ["46%", "46%"],

            roseType: "radius",
            itemStyle: {
              borderRadius: 5,
            },
            label: {
              show: false,
            },
            emphasis: {
              label: {
                show: true,
              },
            },
            avoidLabelOverlap: false,
            itemStyle: {
              // borderRadius: 10,
              // borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: this.chartdata,
          },
        ],
      };
      this.lineChart.setOption(option);
    },

    handleCurrentChange(currentPage) {
      this.pageNum = currentPage;
      // document.querySelector("#anchor").scrollIntoView(true);
      // this.setContextData("tiaozhuan1", this.pageNum);
      this.getTradeList();
    },
    async getTradeList() {
      let formData = new FormData();
      let params = {
        pageNum: this.pageNum,
        pageSize: 20,
      };
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await GetTxList(formData);
       //console.log(res);
      //this.yesterdayTradingValume = res.result.yesterdayTradingValume;
      // this.yesterdayTradingValume = parseFloat(
      //   res.result.increaseVolume
      // ).toFixed(3);

      // if (Number(this.yesterdayTradingValume) > 0) {
      //   this.yesterdayTradingValume = "+" + this.yesterdayTradingValume;
      // }
      if (parseFloat(res.result.increaseVolume) > 1000000) {
        this.yesterdayTradingValume =
          Number(
            (parseFloat(res.result.increaseVolume) / 1000000).toFixed(3)
          ).toLocaleString() + "m";
      } else if (parseFloat(res.result.increaseVolume) > 100000000) {
        this.yesterdayTradingValume =
          Number(
            (parseFloat(res.result.increaseVolume) / 100000000).toFixed(3)
          ).toLocaleString() + "b";
      } else if (parseFloat(res.result.increaseVolume) < 1000000) {
        this.yesterdayTradingValume = parseFloat(
          res.result.increaseVolume
        ).toFixed(3);
      }
      this.totalTxCount = res.result.totalTxCount;
      if (parseFloat(res.result.totalVolume) > 1000000) {
        this.totalTradingValume =
          Number(
            (parseFloat(res.result.totalVolume) / 1000000).toFixed(3)
          ).toLocaleString() + "m";
      } else if (parseFloat(res.result.totalVolume) > 100000000) {
        this.totalTradingValume =
          Number(
            (parseFloat(res.result.totalVolume) / 100000000).toFixed(3)
          ).toLocaleString() + "b";
      } else if (parseFloat(res.result.totalVolume) < 1000000) {
        this.totalTradingValume = parseFloat(res.result.totalVolume).toFixed(3);
      }
      // this.totalTradingValume = parseFloat(res.result.totalVolume).toFixed(3);
      this.yesterdayTxCount = res.result.yesterdayTxCount;
      this.pastdays = res.result.dailyTxnDistribution.pastTime;
      // console.log(this.pastdays);
      //  console.log(res.result.dailyTxnDistribution);
      this.todayCallContractCount =
        res.result.dailyTxnDistribution.todayCallContractCount;
      this.todayClaimingBonusCount =
        res.result.dailyTxnDistribution.todayClaimingBonusCount;
      this.todayInvestAndDisInvestCount =
        res.result.dailyTxnDistribution.todayInvestAndDisInvestCount;
      this.todayStakeAndUnstakeCount =
        res.result.dailyTxnDistribution.todayStakeAndUnstakeCount;
      this.todayTransferCount =
        res.result.dailyTxnDistribution.todayTransferCount;
      //  console.log(this.todayTransferCount);
      this.total = res.result.totalTxCount;
      this.txCount = res.result.yesterdayTxCount;
      // console.log(this.todayTransferCount);
      // console.log(this.txCount);
      this.chartdata = [
        {
          value: this.todayTransferCount,
          name: "Transfer",
          time: this.pastdays,
          sums: (
            ((this.todayTransferCount) / (this.txCount)) *
            100
          ).toFixed(2),
        },
        {
          value: this.todayStakeAndUnstakeCount,
          name: "Staking/Unstaking",
          time: this.pastdays,
          sums: (
            ((this.todayStakeAndUnstakeCount) /
            (this.txCount)) *
            100
          ).toFixed(2),
        },
        {
          value: this.todayInvestAndDisInvestCount,
          name: "Delegation/Withdrawal",
          time: this.pastdays,
          sums: (
            ((this.todayInvestAndDisInvestCount) /
            (this.txCount)) *
            100
          ).toFixed(2),
        },
        {
          value: this.todayClaimingBonusCount,
          name: "Claiming bonuses",
          time: this.pastdays,
          sums: (
            ((this.todayClaimingBonusCount) /
            (this.txCount)) *
            100
          ).toFixed(2),
        },
        {
          value: this.todayCallContractCount,
          name: "Triggering  smart contracts",
          time: this.pastdays,
          sums: (
            ((this.todayCallContractCount) /
            formattedNumber(this.txCount)) *
            100
          ).toFixed(2),
        },
      ];
      //console.log(this.chartdata);
      let _this = this;
      _this.list = res.result.txList;
      //console.log(_this.list);
      _this.initCharts();
      this.Tiaoshu = res.result.totalTxCount;
      this.Tiaoshu = "(" + this.Tiaoshu + ")";
      _this.total1 = res.result.totalTxCount;
      // console.log(_this.total1);
      var calctime = new Date();
      let strdate = Math.floor(calctime.getTime() / 1000);
      for (let i = 0; i < _this.list.length; i++) {
        _this.list[i].tokenAmount=formattedNumber( _this.list[i].tokenAmount);
        // console.log( JSON.parse(_this.list[i].nftImageList));
        // console.log( JSON(_this.list[i].nftImageList));

        if (_this.list[i].type1 == "8") {
          _this.list[i].fromEvmAddress1 = _this.list[i].fromEvmAddress;
          _this.list[i].fromEvmAddress = getSubStr(
            _this.list[i].fromEvmAddress,
            0,
            3
          );
          //  _this.list[i].
          _this.list[i].toEvmAddress1 = _this.list[i].toEvmAddress;
          _this.list[i].toEvmAddress = getSubStr(
            _this.list[i].toEvmAddress,
            0,
            3
          );
        }

        let timestamp = Math.floor(_this.list[i].tradeTime / 1000);
        var s = strdate - timestamp;
        if (s <= 0) {
          s = 1;
        }
        _this.list[i].tradeTime = formatSeconds(s);
        _this.list[i].txHasha = _this.list[i].txHash;
        _this.list[i].txHash = getSubStr(_this.list[i].txHash, 0, 3);

        // if (_this.list[i].tokenAmount.length > 8) {
        //   //  console.log(_this.list[i]);
        //   if (_this.list[i].standard == "ERC-20" && _this.list[i].type == 8) {
        //     // console.log('我走这里');
        //     // _this.list[i].tokenAmount= (Number(_this.list[i].tokenAmount).toLocaleString()).slice(0, 8)
        //     // _this.list[i].tokenAmount =_this.list[i].tokenAmount.slice(0,8)+'...';
        //     _this.list[i].tokenAmount =
        //     formattedNumber(_this.list[i].tokenAmount.slice(0, 8))+
        //       "...";
        //   }
        //   // _this.list[i].tokenAmount =_this.list[i].tokenAmount.slice(0,8)+'...';
        // }
        // _this.list[i].tokenAmount =(parseFloat( _this.list[i].tokenAmount.split(",")[0])).toFixed(8);
        //  if(countDecimalPlaces(_this.list[i].tokenAmount)>8){
        //   _this.list[i].tokenAmount =Number((_this.list[i].tokenAmount).toString().match(/^\d+(?:\.\d{0,8})?/));
        //   }
        //this.list1[i].tokenAmount=   Number((this.list1[i].tokenAmount).toString().match(/^\d+(?:\.\d{0,7})?/));

        // _this.list[i].fromAddress1 = _this.list[i].fromAddress;
        // _this.list[i].fromAddress = getSubStr(
        //   _this.list[i].fromAddress,
        //   0,
        //   6
        // );

        // console.log(_this.list[i].toAddress);
        // _this.list[i].toAddress1 = _this.list[i].toAddress;
        // _this.list[i].toAddress = getSubStr(_this.list[i].toAddress, 0, 6);

        if (_this.list[i].type == 7) {
          _this.list[i].amount = "0";
        } else if (_this.list[i].type == 8) {
          _this.list[i].amount = "0";
        }
        _this.list[i].type1 = _this.list[i].type;
        if (_this.list[i].type == 8) {
          _this.list[i].toAddress = _this.list[i].toEvmAddress;
          _this.list[i].fromAddress = _this.list[i].fromEvmAddress;

          _this.list[i].type = _this.list[i].functions;
        }
        _this.list[i].toAddress1 = _this.list[i].toAddress;
        _this.list[i].fromAddress1 = _this.list[i].fromAddress;
        _this.list[i].fromAddress = getSubStr(_this.list[i].fromAddress, 0, 3);
        _this.list[i].toAddress = getSubStr(_this.list[i].toAddress, 0, 3);

        _this.list[i].type = listType(_this.list[i].type);
        if (_this.list[i].logo == "" && _this.list[i].type == "mint") {
          _this.list[i].logo = _this.imgurl1;
        }
        if (_this.list[i].logo == "" && _this.list[i].type !== "mint") {
          _this.list[i].logo = _this.imgurl;
        }
        if (
          _this.list[i].type1 == "8" &&
          _this.list[i].standard == "ERC-721" &&
          _this.list[i].nftImageList !== ""
        ) {
          var images = JSON.parse(_this.list[i].nftImageList);
          // console.log(images);
          _this.list[i].logo = images[0];
          _this.list[i].nftNameList = JSON.parse(_this.list[i].nftNameList);
          _this.list[i].contractName = _this.list[i].nftNameList[0];
        } else {
          if (_this.list[i].type == "mint") {
            _this.list[i].logo = this.imgurl1;
          }
          if (_this.list[i].functions == "transferFrom") {
            _this.list[i].logo = _this.imgurl1;
          }
        }
        if (_this.list[i].standard !== "ERC-20" && _this.list[i].logo == "") {
        //  console.log("走这里来");
          if (_this.list[i].type1 == 7) {
            _this.list[i].logo = this.imgurl;
          } else {
            _this.list[i].logo = this.imgurl1;
          }
        }
        //判断合约名字为空的时候
        if (_this.list[i].type1 == "7" && _this.list[i].standard == "ERC-721") {
          //console.log(333);
          if (_this.list[i].contractName == "") {
            _this.list[i].contractName = getSubStr(
              _this.list[i].contractAddress,
              0,
              3
            );
          }
        }
        if (
          _this.list[i].type1 == "7" &&
          _this.list[i].standard == "ERC-20" &&
          _this.list[i].contractName == ""
        ) {
          // console.log(2222);
          if (_this.list[i].symbol == "") {
            _this.list[i].symbol = getSubStr(
              _this.list[i].contractAddress,
              0,
              3
            );
          }
          // _this.list[i].symbol =getSubStr(_this.list[i].contractAddress,0,3);
        }
        //合约不被识别的时候
        if (
          _this.list[i].type1 == "8" &&
          _this.list[i].standard == "ERC-721" &&
          (_this.list[i].functions == "Contract Execute" ||
            _this.list[i].functions == "setBaseTokenURI" ||
            _this.list[i].functions == "balanceOf")
        ) {
          if (_this.list[i].logo == "") {
            _this.list[i].logo = this.imgurl;
          } else {
            _this.list[i].logo = _this.list[i].logo;
          }
        }

        if (_this.list[i].type1 == "8" && _this.list[i].standard == "ERC-20") {
         // console.log(_this.list.tokenAmount);
          if (_this.list[i].tokenAmount > 999) {
            _this.list[i].tokenAmount = formattedNumber(_this.list[i].tokenAmount);
              
            
          }
          if (_this.list[i].symbol.trim() == "") {
            if (_this.list[i].contractName.trim() !== "") {
              _this.list[i].symbol = _this.list[i].contractName;
            } else {
              _this.list[i].symbol = getSubStr(
                _this.list[i].contractAddress,
                0,
                3
              );
            }
          }
        }

        //判断如果type=99时候为申领交易
        // if( _this.list[i].type=="Bonus" &&  _this.list[i].fromAddress=="Bonus"){
        //   _this.list[i].type1=99;
        // }
        //  console.log(_this.list[i]);
      }
    },
    goDetail(name, query) {
      //  console.log(query);
      switch (name) {
        case "hash":
          this.$router.push({
            path: "/m/TransferDetails",
            query: {
              txHash: query.txHasha,
              type: query.type1,
              standard: query.standard,
            },
          });

          break;
        case "transfer":
          this.$router.push({
            path: "/m/Address",
            query: { address: query },
          });
          break;
        case "height":
          this.$router.push({
            path: "/m/BlockHeight",
            query: { height: query },
          });
          break;
      }
    },
    gltimea(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },
  },
};
</script>
<style lang="less">
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #22252e;
  color: #fff;
  font-size: 24px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 400;
  border: none;
}
.el-pager li {
  margin: 0px 6px !important;
  padding: 0px 6px !important;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev {
  background: none;
  color: #adb0c7;
  width: 10px !important;
}

.el-pagination.is-background .el-pager li {
  padding-left: 6px;
  padding-right: 6px;
  height: 48px;
  margin: 0 10px;
  //background: #3c485c;
  background: none;
  border-radius: 8px;
  opacity: 1;

  font-size: 24px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 48px;

  text-align: center;
}
</style>

<style lang="less" scoped>
.el-pagination {
  padding-bottom: 32px !important;
}
.index {
  width: 750px;
  margin: 110px auto 0px auto;
  background: #13161b;
  text-align: center;
  .tranbox {
    width: 702px;
    height: 1360px;

    background: #000000;
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    margin: 0 auto;
    .tranboxtit {
      text-align: left;
      height: 42px;
      font-size: 30px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 42px;
      padding-top: 24px;
      margin-left: 24px;
      margin-bottom: 48px;
    }
    .indexbox {
      width: 654px;
      height: 208px;
      background: #13161b;
      border-radius: 24px 24px 24px 24px;
      opacity: 1;
      margin: 0 auto;
      display: flex;
      margin-bottom: 24px;
      justify-content: space-between;
      .iboxleft {
        margin-left: 24px;
        .iboxtit {
          margin-top: 24px;
          height: 34px;
          text-align: left;
          font-size: 24px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #8a8a8a;
          line-height: 34px;
        }
        .iboxcon {
          height: 62px;
          font-size: 44px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 62px;
          margin-bottom: 24px;
          margin-top: 2px;
          text-align: left;
        }
        .iboxbottom {
          display: flex;
          .ibttol {
            height: 34px;
            font-size: 24px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #00e79a;
            line-height: 34px;
          }
          .ibttor {
            margin-left: 16px;
            height: 34px;
            font-size: 24px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #8a8a8a;
            line-height: 34px;
          }
        }
      }
      .iboxright {
        margin-right: 24px;
        img {
          margin-top: 64px;
          width: 84px;
          height: 84px;
        }
      }
    }
    .trancharts {
      width: 654px;
      // height: 899px;
      background: #13161b;
      border-radius: 16px 16px 16px 16px;
      opacity: 1;
      margin: 0 auto;
      .charts_tit {
        display: flex;
        justify-content: space-between;
        padding-top: 24px;
        .charts_l {
          margin-left: 24px;
          height: 42px;
          font-size: 30px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #8a8a8a;
          line-height: 42px;
          img {
            width: 40px;
            height: 40px;
            margin-top: 4px;
          }
        }
        .charts_btn {
          margin-right: 24px;
          width: 127px;
          height: 44px;
          background: #000000;
          border-radius: 13px 13px 13px 13px;
          opacity: 1;
          span {
            font-size: 24px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            margin-left: 20px;
          }
          img {
            width: 40px;
            height: 40px;
          }
        }
      }
      .charts {
        .chartsul {
          width: 654px;
          margin: 0 auto;
          // margin-top: 44px;
          padding-bottom: 24px;
          .chartli:nth-child(1) {
            .markers {
              background: #00e79a;
            }
          }
          .chartli:nth-child(2) {
            .markers {
              background: #14c9c9;
            }
          }
          .chartli:nth-child(3) {
            .markers {
              background: #f7ba1e;
            }
          }
          .chartli:nth-child(4) {
            .markers {
              background: #7a2ce7;
            }
          }
          .chartli:nth-child(5) {
            .markers {
              background: #3491fa;
            }
          }
          .chartli:nth-child(6) {
            .markers {
              background: #7c9ffc;
            }
          }
          .chartli:nth-child(7) {
            .markers {
              background: #9e3820;
            }
          }
          .chartli {
            height: 56px;
            font-size: 27px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #898b8d;
            line-height: 56px;
            display: flex;
            justify-content: space-between;
            margin-left: 20px;
            margin-right: 24px;
            // padding-bottom: 24px;
            .chartlil {
              display: flex;
              span {
                display: block;
                text-align: left;
                word-spacing: -1px;
              }
              .markers {
                display: block;
                width: 12px;
                height: 12px;

                opacity: 1;
                border-radius: 50%;
                margin-top: 20px;
                margin-right: 6px;
              }
            }
            .chartlir {
              span:nth-child(1) {
                color: #fff;
              }
              span:nth-child(2) {
                color: #8d8d8d;
                font-size: 28px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
              }
            }
          }
        }
      }
    }
    // .trancharts {
    //   width: 654px;
    //   height: 780px;
    //   // border: 1px solid green;
    //   background: #13161b;
    //   border-radius: 16px 16px 16px 16px;
    //   opacity: 1;
    //   margin: 0 auto;
    //   .charts_tit {
    //     display: flex;
    //     justify-content: space-between;
    //     padding-top: 24px;
    //     .charts_l {
    //       margin-left: 24px;
    //       height: 42px;
    //       font-size: 30px;
    //       font-family: PingFang SC-Medium, PingFang SC;
    //       font-weight: 500;
    //       color: #8a8a8a;
    //       line-height: 42px;
    //     }
    //     .charts_btn {
    //       margin-right: 24px;
    //       width: 127px;
    //       height: 44px;
    //       background: #000000;
    //       border-radius: 13px 13px 13px 13px;
    //       opacity: 1;
    //       span {
    //         font-size: 24px;
    //         font-family: PingFang SC-Medium, PingFang SC;
    //         font-weight: 500;
    //         color: #ffffff;
    //         margin-left: 20px;
    //       }
    //       img {
    //         width: 40px;
    //         height: 40px;
    //       }
    //     }
    //   }
    // }
  }
  .translist {
    width: 100%;
    overflow: hidden;
    margin-top: 24px;
    background: #13161b;
    .Block_Top {
      text-align: left;
      width: 702px;
      height: 80px;
      line-height: 80px;
      margin: 0 auto;
      background: #0b0c0f;
      border-radius: 24px 24px 0 0;
      span {
        font-size: 30px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        margin-left: 24px;
      }
      b {
        margin-left: 10px;
      }
    }
    //轮播图片开始
    .resume-list {
      width: 702px;
      background: #0b0c0f;
      border-radius: 0 0 24px 24px;
      margin: 0 auto;
      .pool_main {
        width: 100%;
      }
      .tags {
        display: flex;
        overflow: auto;
        white-space: nowrap;
      }
      //隐藏滚动条
      .tags::-webkit-scrollbar {
        display: none;
      }
      // 列表开始
      .indexList {
        width: 100%;
        margin: 0;
        padding: 0;
        background: #0b0c0f;
        .Block_list {
          .block_list_Top {
            display: flex;
            width: 1800px;
            height: 82px;
            line-height: 82px;
            background: #13161b;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            li {
              font-size: 28px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              height: 82px;
              line-height: 82px;
              -webkit-background-clip: text;
              // flex: 0 0 14%;
              text-align: left;
            }
            li:nth-child(1) {
              // border: 1px solid red;
              margin-left: 24px;
              width: 200px;
            }
            li:nth-child(2) {
              width: 200px;
            }
            li:nth-child(3) {
              width: 300px;
              // border: 1px solid red;
            }
            li:nth-child(4) {
              width: 400px;
            }
            li:nth-child(5) {
              width: 200px;
              text-align: center;
            }
            li:nth-child(6) {
              width: 200px;
              text-align: center;
            }
            li:nth-child(7) {
              width: 300px;
            }
          }
        }
        .Block_List_center {
          width: 1800px;
          // border:1px solid red;
          ul {
            //  height: 620px;
            width: 1800px;
            margin: 0;
            padding: 0;
            //padding: 0 19px;
            li:last-child {
              // border-bottom: none;
            }
            li {
              display: flex;
              height: 82px;
              border-bottom: 1px solid #22252e;
              line-height: 82px;
              margin-left: 24px;
              // width: 200px;
              p {
                font-size: 26px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                text-align: left;
                // flex: 0 0 14%;
                img {
                  border-radius: 50%;
                }
              }
            }
            li:last-child {
              // border-bottom: none;
            }
            p:nth-child(1) {
              width: 200px;
              // border: 1px solid red;
            }
            p:nth-child(2) {
              width: 200px;
            }
            p:nth-child(3) {
              width: 300px;
              color: #8a8a8a;
              //  border: 1px solid red;
            }
            p:nth-child(4) {
              width: 400px;
              color: #8a8a8a;
            }
            p:nth-child(5) {
              width: 200px;
              text-align: center;
            }
            p:nth-child(6) {
              width: 200px;
              text-align: center;
            }
            p:nth-child(7) {
              width: 300px;
              color: #8a8a8a;
              text-align: left;
              // border: 1px solid red;
            }
          }
        }
      }
      .block {
        margin-top: 70px;
        padding-bottom: 70px;
        font-size: 28px;
        font-family: "PingFang SC-中黑体, PingFang SC";
        font-weight: normal;
        color: #adb0c7;
        // line-height: 39px;
      }
    }

    //轮播图片结束
  }
  .list {
    text-align: center;
    padding-bottom: 80px;
  }
  .list-data {
    margin: 30px auto 0px auto;
    width: 690px;
    min-height: 1197px;
    /*height: 1197px;*/
    /*height: 920px;*/
    background: #232a35;
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    .block {
      margin-top: 32px;
      padding-bottom: 70px;
      font-size: 28px;
      font-family: "PingFang SC-中黑体, PingFang SC";
      font-weight: normal;
      color: #adb0c7;
      // line-height: 39px;
    }
  }

  .head {
    width: 690px;
    padding: 24px 12px;
    // margin:32px 0 32px 32px;
    background: #232a35;
    opacity: 1;
    border-radius: 16px 16px 16px 16px;
    padding-left: 30px;
    text-align: left;
    height: 48px;
    font-size: 32px;
    font-family: SF Pro Text-Medium, SF Pro Text;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
    line-height: 48px;
    span {
      font-size: 26px;
      font-family: "PingFang SC-中黑体, PingFang SC";
      font-weight: normal;
      color: #b2b7c2;
      line-height: 36px;
    }
  }
  .xian {
    border-bottom: none !important;
  }
  .list-height {
    min-height: 1197px;
    .content_center {
      text-align: left;
      padding: 40px 0px 40px 0px;
      font-size: 26px;
      font-family: "PingFang SC-中黑体, PingFang SC";
      font-weight: normal;
      color: #adb0c7;
      line-height: 36px;
      border-bottom: 1px solid #3c485c;
      margin: 0px 32px;
      div {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 16px;
        height: 44px;
        line-height: 44px;
        font-size: 28px;
        font-family: SF Pro Text-Medium, SF Pro Text;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.55);
      }
      span {
        padding-bottom: 10px;
        width: 447px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
        float: right;
        height: 44px;
        font-size: 28px;
        font-family: SF Pro Text-Regular, SF Pro Text;
        font-weight: 400;
        color: #00a870;
        padding-left: 32px;
        line-height: 44px;
      }
      .blacka {
        color: #8a8a8a !important;
      }
      .black {
        height: 44px;
        font-size: 28px;
        font-family: SF Pro Text-Regular, SF Pro Text;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.9);
        line-height: 44px;
        padding-left: 32px;
      }
      span:nth-child(4) {
        color: #2c3852 !important;
      }
      span:nth-child(5) {
        color: #2c3852 !important;
      }
      img {
        width: 48px;
        height: 48px;
        float: right;
        vertical-align: center !important;
      }
    }
  }
}
</style>
